import React from 'react';
import styles from './AdminInput.module.css';

const CENTS_STEP_VALUE = '.01';

const AdminInput = ({
  label,
  value,
  name,
  onChange,
  placeholder,
  disabled,
  style,
  required,
  propRef,
  type,
  characterLimit,
  error,
  //used for inputs in Payment.js that are using Recurly
  dataRecurly,
}) => {
  const resolveInputByType = () => {
    switch (type) {
      case 'text': {
        return (
          <input
            className={`${styles.input} ${error ? styles.error : ''}`}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            type="text"
            required={required}
            disabled={disabled}
            maxLength={characterLimit || ''}
            //to handle any custom validations
            ref={propRef}
            data-recurly={dataRecurly}
          />
        );
      }
      case 'textArea': {
        return (
          <textarea
            className={`${styles.input} ${styles.textArea} ${
              error ? styles.error : ''
            }`}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            required={required}
            maxLength={characterLimit || ''}
            ref={propRef}
          />
        );
      }
      case 'price': {
        return (
          <div className={styles.priceInput}>
            <i className="far fa-dollar-sign" />
            <input
              className={`${styles.input} ${error ? styles.error : ''}`}
              name={name}
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              type="number"
              step={CENTS_STEP_VALUE}
              min="0"
              pattern="^\d*(\.\d{0,2})?$"
              required={required}
              disabled={disabled}
              maxLength={characterLimit || ''}
              ref={propRef}
            />
          </div>
        );
      }

      default: {
        return (
          <input
            className={`${styles.input} ${error ? styles.error : ''}`}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            type={type}
            required={required}
            disabled={disabled}
            maxLength={characterLimit || ''}
            ref={propRef}
          />
        );
      }
    }
  };

  return (
    <div className={styles.container} style={style}>
      <label htmlFor={name}>{label}</label>
      {resolveInputByType()}
      {/*color attribute error must be handled separately due to design of input*/}
      {error && label !== 'Color Attribute' && (
        <p className={styles.errorMessage}>{error}</p>
      )}
    </div>
  );
};

export default AdminInput;
